import { IconButton, SvgComment, TextButton, Tooltip } from '@loomhq/lens';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TIMELINE_COMMENT_FTUX } from 'constants/triggers';
import { activateTriggerCreator } from 'creators/triggers.js';
import { videoPlayerEnterCommentMode } from 'creators/videoPlayer';
import { getParam } from 'utilities/url';

import useMedia from 'hooks/useMedia';
import { useShouldShowTrigger } from 'hooks/triggers';

import CommentNewFeatureWrapper from '../comment-new-feature-wrapper';

import styles from './styles.module.less';

// related to Timeline Comments: timeline-comments-by-creator
const LAUNCH_DATE = '2021-02-01T00:00:00.000Z';

// wrap the comment button in either the new feature overlay, or a regular tooltip wrapper, but not both
const CommentButtonWrapper = props => {
  const dispatch = useDispatch();
  const { onEmbedPlayer, controlBarExpanded, children } = props;

  const startedPlaying = useSelector(state => state.video_player.has_started);
  const fistTimeTrigger = useShouldShowTrigger(TIMELINE_COMMENT_FTUX);
  const userCreatedAt = useSelector(state => state.user.current.createdAt);

  const showOnSharePage = !onEmbedPlayer && startedPlaying;
  const showOnEmbed = onEmbedPlayer && controlBarExpanded;
  const createdBeforeLaunch = userCreatedAt < LAUNCH_DATE;

  const showFirstTimeTips =
    createdBeforeLaunch && fistTimeTrigger && (showOnSharePage || showOnEmbed);

  useEffect(() => {
    const override = getParam('commentsFtuxOverride');

    if (override) {
      console.log('sending trigger reset');

      dispatch(activateTriggerCreator(TIMELINE_COMMENT_FTUX));

      window.history.replaceState('', '', window.location.pathname);
    }
  }, [dispatch]);

  return (
    <>
      {showFirstTimeTips && (
        <CommentNewFeatureWrapper onEmbedPlayer={onEmbedPlayer}>
          {children}
        </CommentNewFeatureWrapper>
      )}
      {!showFirstTimeTips && (
        <Tooltip content="Comment (c)">{children}</Tooltip>
      )}
    </>
  );
};

const CommentButton = props => {
  const { onEmbedPlayer, controlBarExpanded, useTextButton, disabled } = props;
  const dispatch = useDispatch();

  const fullSize = useMedia(['(min-width: 560px)'], [true], false);
  const iconButtonSize = fullSize ? 'medium' : 'small';

  const enterCommentMode = () => {
    dispatch(videoPlayerEnterCommentMode());
  };

  function renderAsTextButton() {
    return (
      <TextButton
        data-testid="comment-reaction-button"
        isDisabled={disabled}
        altText="Leave a comment"
        onClick={enterCommentMode}
        size={iconButtonSize}
        icon={<SvgComment color={onEmbedPlayer ? 'white' : null} />}
      >
        Comment
      </TextButton>
    );
  }

  function renderAsIconButton() {
    return (
      <IconButton
        data-testid="comment-reaction-button"
        isDisabled={disabled}
        altText="Leave a comment"
        onClick={enterCommentMode}
        size={iconButtonSize}
        icon={<SvgComment color={onEmbedPlayer ? 'white' : null} />}
      >
        Comment
      </IconButton>
    );
  }

  const buttonComponent = useTextButton
    ? renderAsTextButton()
    : renderAsIconButton();

  return (
    <div className={styles.commentTooltip}>
      {disabled ? (
        buttonComponent
      ) : (
        <CommentButtonWrapper
          controlBarExpanded={controlBarExpanded}
          onEmbedPlayer={onEmbedPlayer}
        >
          {buttonComponent}
        </CommentButtonWrapper>
      )}
    </div>
  );
};

export default CommentButton;
